import * as React from "react";
import type { SVGProps } from "react";
const SvgTradingbotIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="tradingbot_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M468.992 120.917a42.667 42.667 0 0 1 42.667-42.666h78.208a42.667 42.667 0 1 1 0 85.333H554.41l-.171 67.541h153.088a163.541 163.541 0 0 1 163.584 163.542v39.338a117.333 117.333 0 0 1 110.25 117.12v78.251a117.333 117.333 0 0 1-110.25 117.12v39.296a163.541 163.541 0 0 1-163.584 163.541H316.203A163.541 163.541 0 0 1 152.66 785.792v-39.296A117.333 117.333 0 0 1 42.496 629.333v-78.208a117.333 117.333 0 0 1 110.165-117.12v-39.338a163.541 163.541 0 0 1 163.542-163.542h152.746l.214-106.496a42.496 42.496 0 0 1-.171-3.712zm433.92 508.459v-78.208a39.125 39.125 0 0 0-32-38.485V667.86a39.125 39.125 0 0 0 32-38.485zm-750.25 38.443V512.683a39.125 39.125 0 0 0-31.958 38.485v78.208c0 19.157 13.781 35.072 32 38.443zm85.333.682v117.291c0 43.179 34.986 78.208 78.208 78.208h391.125c43.221 0 78.25-34.987 78.25-78.208V394.667c0-43.179-35.029-78.208-78.25-78.208H316.203c-43.179 0-78.208 34.986-78.208 78.208V512h.042v156.501zM417.707 512a42.667 42.667 0 1 0-85.334 0v156.459a42.667 42.667 0 1 0 85.334 0V512zm230.997-42.667A42.667 42.667 0 0 1 691.371 512v156.459a42.667 42.667 0 1 1-85.334 0V512a42.667 42.667 0 0 1 42.667-42.667z"
    />
  </svg>
);
export default SvgTradingbotIcon;
